export const SECRET_KEYS = {
    WVC_POST_CAN_API_KEY_SECRET_NAME: 'Canada-Post-Api-Key',
    WVC_POSTGRID_API_KEY_SECRET_NAME: 'Postgrid-api-key'
    // Add more keys as needed
};